import {Component, Inject, OnInit, ViewEncapsulation} from "@angular/core";
import {BehaviorSubject, Subject} from "rxjs";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {
    ExpirationConfigurationDto
} from "../../../../model/club-gigot/expiration-configuration/expiration-configuration.dto";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material";
import {ConfigurationService} from "../../../../service/club-gigot/configuration.service";
import {CampaignService} from "../../../../core/services/campaign.service";
import {CampaignDTO} from "../../../../core/models/campaignDTO.model";

@Component({
  selector: 'kt-dialog-points-expiration-configuration',
  templateUrl: './dialog-points-expiration-configuration.component.html',
  styleUrls: ['./dialog-points-expiration-configuration.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class DialogPointsExpirationConfigurationComponent implements OnInit {

    public _isEditMode : boolean = false;

    public loading$ = new BehaviorSubject(true);

    public pointsExpirationForm : FormGroup;

    public error = new BehaviorSubject('');

    public campaigns$ : Subject<CampaignDTO[]> = new Subject<CampaignDTO[]>();


    constructor(private dialogRef: MatDialogRef<DialogPointsExpirationConfigurationComponent>,
                private configurationService : ConfigurationService,
                private campaignService: CampaignService,
                @Inject(MAT_DIALOG_DATA)
                public data: PointsExpirationData) { }

    ngOnInit() {
        this.buildForm();
        this.loading$.next(false)

    }
    public ngAfterViewInit(): void {
        this.loadCampaigns();
    }
    public buildForm(){
        if(this.data.entity)
            this._isEditMode = true;

        this.pointsExpirationForm = new FormGroup({
            id : new FormControl(this._isEditMode ? this.data.entity.id : null),
            startCampaignSequence: new FormControl(this._isEditMode ? this.data.entity.startCampaignSequence : null, [Validators.required]),
            campaignsToExpire: new FormControl(this._isEditMode ? this.data.entity.campaignsToExpire : null, [Validators.required]),
        })
    }

    public loadCampaigns() : void {
        this.campaignService.getCampaigns().subscribe({
            next: (campaigns : CampaignDTO[]) => this.campaigns$.next(campaigns),
            error: (_ : Error) => this.campaigns$.next([])
        });
    }

    public onNoClick(): void {
        this.dialogRef.close();
    }

    public onSaveConfiguration() : void {
        let dto = new ExpirationConfigurationDto();
        dto.id = this._isEditMode? this.data.entity.id : undefined;
        dto.campaignsToExpire =  this.pointsExpirationForm.controls['campaignsToExpire'].value;
        dto.startCampaignSequence =  this.pointsExpirationForm.controls['startCampaignSequence'].value;
        this.loading$.next(true)
        this.configurationService.saveConfiguration(dto, this._isEditMode)
            .subscribe({
                next : (_ : any) => this.dialogRef.close(),
                error : (error : Error) => this.error.next("Error. Intentelo de nuevo o llame a sistemas")
            })
    }


}

export class PointsExpirationData {
    public entity : ExpirationConfigurationDto;

    constructor(entity : ExpirationConfigurationDto){
        this.entity = entity;
    }
}

